module.exports = __webpack_public_path__ + "static/img/ic_empty_404@3x.cd23e28f.png";